<template>
  <div v-if="current" class="wrap">
    <div class="onetitle" :class="{'text-center': headerAlign == 'center'}">{{ current.name }}</div>
    <div class="maintent">
      <el-scrollbar wrap-style="overflow-x:hidden;" style="height:calc(100vh - 280px)">
        <div v-for="(v,i) in current.tent" :key="i" class="morediv">
          <p class="title">{{ v.title }}</p>
          <p class="main">{{ v.main }}</p>

          <div class="morep">
            <p v-for="(q,w) in v.mainarr" :key="w">{{ q.mainp }}</p>
          </div>

          <p class="section">{{ v.section }}</p>
          <div v-for="(j,k) in v.children" :key="k" class="secondiv">
            <p class="secondtitle">{{ j.childtitle }}</p>
            <p class="secondmain">{{ j.childtent }}</p>
            <p class="secondsection">{{ j.childsection }}</p>
          </div>
        </div>
      </el-scrollbar>

    </div>
  </div>
</template>

<script>
import {
  privacyPolicy,
  termsAndConditions,
  shippingPolicy,
  returnPolicy,
  price
} from '@/assets/protocol'
export default {
  props: {
    type: {
      type: String,
      default: 'privacyPolicy'
    },

    headerAlign: {
      type: String,
      default: 'left'
    }
  },

  data() {
    return {
      privacyPolicy,
      termsAndConditions,
      shippingPolicy,
      returnPolicy,
      price
    }
  },

  computed: {
    current() {
      return this[this.type]
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .onetitle {
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 20px;
    line-height: 50px;
    color: #000;
    // border-bottom: 1px solid #606266;
  }
  .maintent{
      .morediv{
          .title{
              line-height: 50px;
              font-weight: 700;
              font-size: 15px;
              color: #000;
          }
          .section{
              margin-top: 15px;
          }
          .secondiv{
              .secondtitle{
                  line-height: 30px;
                  color: #000;
                  font-weight: 700;
              }
              .secondsection{
                margin-top: 15px;
              }
          }
      }
  }
}
</style>
